/**
 * Tool directory. A list, not a dashboard: the point of the playground is that
 * a new tool appears here without any layout being redesigned.
 */

import { Link } from "react-router-dom";
import { FiCpu, FiFileText } from "react-icons/fi";
import { Card, PillBadge } from "@/components/ui";
import { BADGE_TONE } from "@/components/ui/pillTones";

const TOOLS = [
  {
    path: "/ocrlab",
    name: "OCR Lab",
    icon: <FiCpu />,
    blurb:
      "Run one PDF page through dots.ocr and Unlimited-OCR side by side. Start and stop the GPUs, edit each model's prompt, overlay the boxes each model found, and save runs.",
    tag: "GPU",
  },
  {
    path: "/pdflab",
    name: "PDF Lab",
    icon: <FiFileText />,
    blurb:
      "Run a PDF through OpenDataLoader — a CPU structure parser, not an OCR model. Every flag it has, all six output formats, the boxes it found drawn over the page, and a hybrid mode that adds docling's OCR for scanned pages.",
    tag: "CPU",
  },
];

export default function Home() {
  return (
    <div className="mx-auto max-w-3xl px-6 py-10">
      <header className="mb-6">
        <h1 className="text-xl font-semibold text-fh-text-title">Tools</h1>
        <p className="mt-1 text-fh-body text-fh-text-secondary">
          Internal bench for trying things that are not ready for the pipeline.
        </p>
      </header>

      <div className="space-y-3">
        {TOOLS.map((t) => (
          <Link key={t.path} to={t.path} className="block">
            <Card className="p-5 transition hover:border-fh-border">
              <div className="flex items-start gap-3">
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-fh-input bg-fh-surface-avatar text-fh-text-mid">
                  {t.icon}
                </span>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <h2 className="font-medium text-fh-text-strong">{t.name}</h2>
                    {t.tag && <PillBadge value={t.tag} tone={BADGE_TONE.amber} />}
                  </div>
                  <p className="mt-1 text-fh-body leading-relaxed text-fh-text-secondary">{t.blurb}</p>
                </div>
              </div>
            </Card>
          </Link>
        ))}
      </div>

      <p className="mt-8 text-fh-meta leading-relaxed text-fh-text-muted">
        Tools tagged <span className="font-medium">GPU</span> start real hardware that costs money
        while it runs. They stop themselves when idle, but the Stop button is faster.
      </p>
    </div>
  );
}
